module.exports = __webpack_public_path__ + "img/song_des_2.41e02730.jpg";